import { INVITATION_STATUS } from '../../domain/domainCodes.js'
/**
 * English mirror of ./strings.ar.js — GENERATED by scripts/i18n/build.mjs.
 *
 * Wording follows the legacy Locale/*.resx English resources wherever the
 * legacy screen had the same label. To change any of it, edit
 * scripts/i18n/strings.en.json and re-run the script.
 */

export const strings = {
  actionDone: 'Operation completed successfully',
  actionFailed: 'The operation could not be completed',
  title: 'Users Invitations',

  subtitle: 'Users Invitations',
  cardTitle: 'Users Invitations',
  cardHint:
    'Invitations bring new users into the system. Use them for employees who cannot sign in through LDAP/Active Directory.\\n\\nEach invitee receives a link to register on the platform.',

  actions: {
    newInvitation: 'New Invitation',
    manyInvitations: 'Send Many Invitations',
  },

  filter: {
    trigger: 'Filter By Status',
    statusLabel: 'Status:',
    statusPlaceholder: 'Status',
    adminLabel: 'Admin',
    adminPlaceholder: 'For the administrator',
    yes: 'Yes',
    no: 'No',
    reset: 'Cancel',
    submit: 'Search',
  },

  columns: {
    email: 'Email Address',
    group: 'Group',
    createdOn: 'Created On',
    expiryDate: 'Expiry Date',
    status: 'Status',
  },

  stats: {
    caption: 'Invitations at a glance',
    /* Selecting it clears the status filter, so it names a scope, not a figure. */
    all: 'All invitations',
  },

  status: {
    [INVITATION_STATUS.SENT]: 'New',
    [INVITATION_STATUS.USER_REGISTERED]: 'User Accepted',
    [INVITATION_STATUS.CANCELED]: 'Canceled',
  },

  row: {
    resend: 'Resend Email',
    edit: 'Update',
    cancel: 'Cancel Invitation',
    activate: 'Activate Invitation',
    notifications: 'Notifications',
  },

  form: {
    singleTitle: 'invite user',
    bulkTitle: 'invite many users',
    email: 'Email',
    group: 'Group',
    expiry: 'Invitation Link Expiry Date',
    expiryPlaceholder: 'Expiry Date',
    isAdmin: 'Admin',
    save: 'Save',
    send: 'Send',
    emailRequired: 'E-mail is required.',
    emailInvalid: 'Please enter a valid e-mail address.',
    fileRequired: 'Please upload a file in Excel (.xlsx) format',
  },

  excel: {
    intro: 'Please upload a file in Excel (.xlsx) format',
    columnsIntro: 'The file must contain the following columns',
    mandatory: 'Mandatory',
    optional: 'Optional',
    notesTitle: 'Important Notes',
    notes:
      'The first row in the file must contain the column names, exactly matching the names and order shown in the table',
    template: 'View Template',
  },

  resendTitle: 'Resend the invitation email?',
  resendConfirm: 'The invitation will be sent again to:',
  yes: 'Yes',
  no: 'No',
  close: 'Close',
}
